/**
 * Created by he.jianbo 19-11-03
 * 头条号新建稿件
 */
'use strict';
angular.module('editToutiaoToBeCompiledNewsModule', []).controller('editingCenterToutiaohaoNewsCtrl', [
    '$scope',
    '$element',
    '$compile',
    '$q',
    '$state',
    '$validation',
    '$timeout',
    'trsHttpService',
    'initVersionService',
    'modalDialog',
    'jsonArrayToStringService',
    'editingCenterService',
    'storageListenerService',
    'ueditorService',
    'iWoService',
    'globleParamsSet',
    'toutiaohaoService',
    'editingMediatype',
    'beforeonload',
    'editIsLock',
    'newMediaService',
    'toutConst',
    'messagePublishService',
    'sensitiveWordCheckService',
    function (
        $scope,
        $element,
        $compile,
        $q,
        $state,
        $validation,
        $timeout,
        trsHttpService,
        initVersionService,
        modalDialog,
        jsonArrayToStringService,
        editingCenterService,
        storageListenerService,
        ueditorService,
        iWoService,
        globleParamsSet,
        toutiaohaoService,
        editingMediatype,
        beforeonload,
        editIsLock,
        newMediaService,
        toutConst,
        messagePublishService,
        sensitiveWordCheckService
    ) {
        initStatus();
        initData();
        toutiaohaoService.addFuture($scope, ['sendmessage']);

        /**
         * [initStatus description]
         *
         * @return  {[type]}
         *   [return description]
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
            };
            $scope.status = {
                support: {
                    content: '',
                },
                toutiaohaoFormError: [],
                switch: 'manuscriptInfo',
                isOriginal: $state.params.isOriginal,
                progressss: 0,
                topAttachFilePicSize: '235,100',
                toutianhaoarticleid: $state.params.articleid,
                mediaType: editingMediatype.toutiaohao,
                isFusionEditor: $state.current.name == 'fusionnews', // 是否来自融合编辑器
                isEditDraft: !!$state.params.articleid,
                isawaitrevise: !!$state.params.isawaitrevise, // 是否待修订
                hasTimeline: false, // 是否存在流程版本
            };
            $scope.data = {
                originList: [
                    {
                        name: '内部原创',
                        value: '2',
                    },
                    {
                        name: '整合原创',
                        value: '1',
                    },
                    {
                        name: '特约稿',
                        value: '3',
                    },
                    {
                        name: '通讯员稿',
                        value: '4',
                    },
                    {
                        name: '报道组稿',
                        value: '5',
                    },
                    {
                        name: '其他',
                        value: '6',
                    },
                ],
                version: [],
                copyVersion: [],
                comment: {
                    comment: [],
                    voiceObj: {},
                    hasMore: false,
                    currPage: 1,
                },
                trench: toutConst.listenStroageKey,
                scaleImgSize: globleParamsSet.scaleImgSize(),
            };
            $scope.editFlag = {
                media: 'toutiaohao', 
                docType: 'news',
            };
        }

        /**
         * [initData description]
         *
         * @param  {[type]}  dealWithListFun
         *   [dealWithListFun description]
         *
         * @return  {[type]}
         *   [return description]
         */
        $scope.initData = function (dealWithListFun) {
            var defer = $q.defer();
            if (angular.isDefined($state.params.articleid)) {
                initEditData(dealWithListFun).then(function () {
                    defer.resolve();
                });
            } else {
                initNewData(dealWithListFun).then(function () {
                    defer.resolve();
                });
            }
            return defer.promise;
        };

        /**
         * [initData description]初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            if (!$scope.status.isFusionEditor) {
                initArrayBtn();
                ($state.params.articleid ? initEditData() : initNewData()).then(function() {
                    beforeonload.beforeonloadAlert($scope);
                });
            }
            $scope.handleBtnClick = function (funname) {
                eval('$scope.' + funname + '()');
            };
            emitCloseWindow();
        }

        /**
         * [initNewData 初始化新稿件]
         *
         * @param  {[type]}  dealWithListFun
         *   [dealWithListFun description]
         *
         * @return  {[type]}
         *   [return description]
         */
        function initNewData(dealWithListFun) {
            var defer = $q.defer();
            $scope.list = {
                serviceid: 'mlf_toutiao',
                methodName: 'save',
                docKind: 1,
                DOCTYPE: 1,
                METADATAID: 0,
                CHANNELID: $state.params.account,
                TITLE: '',
                HTMLCONTENT: '',
                FGD_EDITINFO: [],
                FGD_AUTHINFO: [{ isCreate: true }],
                ORIGINAL: 0,
                ORIGINALTYPE: 0,
                NEWSSOURCES: '',
                DOCGENRE: '',
                ISNOPAYMENT: '1'
            };
            loadDirective().then(function () {
                defer.resolve();
            });
            initDocgenre();
            // 融合编辑器下处理list
            if ($scope.status.isFusionEditor && angular.isFunction(dealWithListFun)) {
                dealWithListFun();
            }
            return defer.promise;
        }

        /**
         * [initEditData 查询已保存的稿件]
         *
         * @param  {[type]}  dealWithListFun
         *   [dealWithListFun description]
         *
         * @return  {[type]}
         *   [return description]
         */
        function initEditData(dealWithListFun) {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_toutiao',
                methodName: 'getTouTiaoArticle',
                METADATAID: $state.params.articleid,
                CHANNELID: $state.params.account,
            };
            // 适应融合编辑
            if ($scope.status.isFusionEditor) {
                params = {
                    serviceid: 'mlf_fusiontoutiao',
                    methodname: 'getTouTiaoVirtualDoc',
                    SourceDocId: $scope.data.sourceDocId || $state.params.iwometadataid,
                };
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                $scope.list = data;
                $scope.data.remarks = data.REMARKS;
                document.title = data.TITLE;
                $scope.list.serviceid = 'mlf_toutiao';
                $scope.list.methodName = 'save';
                // $scope.data.specialDoc = $scope.list.SPECIALDOC;
                if (!$scope.list.POSTER) {
                    $scope.list.POSTER = '';
                    $scope.list.POSTERURL = '';
                }
                loadDirective().then(function () {
                    defer.resolve();
                });
                // 获取流程版本
                getVersion($scope.list.METADATAID).then(function (data) {
                    defer.resolve();
                });
                initDocgenre($scope.list);
                getPropagandaReview();
                // 融合编辑下处理list
                if ($scope.status.isFusionEditor && angular.isFunction(dealWithListFun)) {
                    dealWithListFun();
                }
            });
            //  稿件加锁
            editIsLock.lockDraft($state.params.articleid);
            return defer.promise;
        }

        /**
         * [initDocgenre 初始化稿件体裁]
         *
         * @param  {[type]}  obj
         *   [obj 数据列表]
         *
         * @return  {[type]}
         *   [return description]
         */
        function initDocgenre(obj) {
            iWoService.initData().then(function (data) {
                $scope.data.docgenre = data.DocGenre;
                $scope.list.DOCGENRE = obj ? obj.DOCGENRE : angular.copy($scope.data.docgenre[0]);
            });
        }

        /**
         * [getPropagandaReview 获取]
         *
         * @return  {[type]}
         *   [return description]
         */
        function getPropagandaReview() {
            var deffer = $q.defer();
            var params = {
                serviceid: 'wcm61_socialprocess',
                methodname: 'queryToJson',
                objType: 20,
                ObjId: $state.params.articleid,
                isXcb: 1,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                if (Object.prototype.toString.call(data) === '[object Array]') {
                    $scope.data.propagandaReview = initVersionService.getDayContent(data, 'push').concat($scope.data.records);
                    deffer.resolve();
                }
            });
            return deffer.promise;
        }

        /**
         * [loadDirective 动态加载指令]
         *
         * @return  {[type]}
         *   [return description]
         */
        function loadDirective() {
            var defer = $q.defer();
            editingCenterService.loadManuscriptType($scope, $element); // 加载稿件原创部分
            if ($state.params.issave === undefined || $state.params.issave === '0') {
                LazyLoad.js(['./lib/ueditor2/ueditor.config.js?v=11.5', './lib/ueditor2/ueditor.all.js?v=11.8'], function () {
                    var ueditor =
                        '<ueditor edit-flag="editFlag" class="newEditor" versionid="data.lastVersionid" type="{{\'newmedia\'}}" infullscreen="status.infullscreen" list="list" has-content="status.hasContent"></ueditor>';
                    ueditor = $compile(ueditor)($scope);
                    $element.find('ueditorLocation').append(ueditor);
                    var ue = UE.getEditor('ueditor');
                    $scope.status.support.content = $scope.list.CONTENT;
                    ue.ready(function () {
                        ue.addListener('keydown', function (type, event) {
                            if (event.keyCode === 13) {
                                $scope.status.support.content = ue.getContentTxt();
                            }
                        });
                        defer.resolve();
                    });
                    var supportCreation =
                        '<support-creation is-trs-check-menu="{{\'true\'}}" parent-status="status" big-face-switch="status.bigFaceSwitch" has-editor="true" is-news="true" media-type="{{\'2\'}}" is-check-sensitive-words="status.isCheckSensitiveWords" list="list"></support-creation>';
                    supportCreation = $compile(supportCreation)($scope);
                    $element.find('supportcreation').append(supportCreation);
                    if (!$scope.status.isFusionEditor) {
                        // 非融合编辑下的加载发稿单
                        $scope.loadFgd();
                    }
                });
            } else {
                defer.resolve();
            }
            return defer.promise;
        }

        /**
         * [loadFgd 加载发稿单]
         *
         * @return  {[type]}
         *   [return description]
         */
        $scope.loadFgd = function () {
            var draftList =
                '<editor-dir list="list"  meta-data-id="{{list.CHNLDOCID}}" editor-json="list.FGD_EDITINFO" editor-form="tthNewsForm"></editor-dir>' +
                '<editor-auth-dir author="list.FGD_AUTHINFO" originalchildtype="list.ORIGINAL==1&&data.originType==3?1:0"></editor-auth-dir>';
            draftList = $compile(draftList)($scope);
            $element.find('editor').append(draftList);
        };

        /* 稿件操作开始*/
        /**
         * [save description] 保存稿件
         * @param {[type]} [flag] [description] 是否为操作前的保存
         * @return {[type]} [description]
         */
        $scope.save = function () {
            var defer = $q.defer();
            saveList(true).then(
                function () {
                    // 保存成功后的处理
                    storageListenerService.addListenerToToutiaohao('save');
                    $scope.status.isEditDraft = true;
                    // 保存结束刷新路由
                    // $state.params.issave = "0";
                    // $state.params = angular.copy($state.params);
                    $state.transitionTo($state.current, $state.params, {
                        reload: false,
                    });
                    // 保存
                    if (!$scope.status.isFusionEditor) {
                        $timeout(function () {
                            modalDialog.saveModel('保存成功', '', 'success');
                        }, 500);
                    }
                    defer.resolve();
                },
                function (error) {
                    if (!$scope.status.isFusionEditor) {
                        modalDialog.alertType('保存失败', '', 'warning', false);
                    }
                    defer.reject(error);
                }
            );
            return defer.promise;
        };

        /**
         * [saveList description]切换时保存list数据
         *
         * @param   {[type]}  flag  [flag description] 判断是否进行加锁操作，如果关闭页面则不加锁，不关闭则加锁
         *
         * @return  {[type]}        [return description]
         */
        function saveList(flag) {
            var defer = $q.defer();
            // 处理发稿单作者信息空数据提交问题
            if ($scope.status.isFusionEditor) {
                $scope.list.serviceid = 'mlf_fusiontoutiao';
                $scope.list.methodName = 'saveToutiaoVirtualDoc';
                $scope.list.SourceDocId = $scope.data.sourceDocId || $state.params.iwometadataid;
                $scope.list.FusionToutiaoId = $state.params.articleid || '0';
            }
            ueditorService.saveContent($scope.list);
            // $validation.validate($scope.tthNewsForm.authorForm);
            $scope.tthNewsForm.$pending = {};
            $validation
                .validate($scope.tthNewsForm)
                .success(function () {
                    modalDialog.isSecretInformation(
                        true,
                        function () {
                            sensitiveWordCheckService.sensitiveWords($scope).then(function (sensitiveWords) {
                                var list = angular.copy($scope.list);
                                list.ORIGINALTYPE = $scope.data.originType;
                                list.SPECIALDOC = $scope.data.specialDoc;
                                list.METADATAID = $state.params.articleid || '0';
                                list = jsonArrayToStringService.jsonArrayToString(list);
                                $scope.tthNewsForm.$setPristine();
                                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), list, 'post').then(function (data) {
                                    $state.params.articleid = $scope.list.articleid = data.METADATAID.replace(/\"/g, ''); // 后台返回的是字符串，需要转成数字类型
                                    beforeonload.refresh($scope);
                                    //  稿件加锁
                                    if (flag) {
                                        editIsLock.lockDraft($state.params.articleid);
                                    }
                                    defer.resolve(data);
                                });
                            });
                        },
                        function () {
                            defer.reject();
                        }
                    );
                })
                .error(function () {
                    editingCenterService.checkSaveError($scope.tthNewsForm, $element, $scope);
                    defer.reject({ plat: '头条号' });
                });
            return defer.promise;
        }

        /**
         * [initArrayBtn description]初始化按钮
         * @return {[type]} [description]
         */
        function initArrayBtn() {
            toutiaohaoService.initEditerBtn($state.params.platform, $state.params.account).then(function(data) {
                $scope.arrayBtn = data;
            });
        }

        /*
         *撤稿操作
         */
        $scope.Kill = function () {
            $scope.loadingPromise = newMediaService.rejection($scope, toutConst.kill).then((opinion) => {
                saveList().then(function () {
                    let toutParams = angular.extend(
                        {
                            ChnlDocIds: $scope.list.RECID,
                            CHANNELID: $state.params.account,
                            opinion: opinion,
                        },
                        toutConst.kill
                    );
                    messagePublishService.publish('doEditPageOperation', toutParams);
                });
            });
            // modalDialog.inputModel('撤稿', '撤稿原因（可选）', function (content) {
            //     saveList().then(function () {
            //         var params = {
            //             serviceid: 'mlf_toutiaooper',
            //             methodname: 'withdrawTouTiaoArticles',
            // ChnlDocIds: $scope.list.RECID,
            // CHANNELID: $state.params.account,
            // Opinion: content,
            //         };
            //         $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
            //             function (data) {
            //                 modalDialog.alertType('撤稿成功', '', 'success', false, function () { });
            //                 storageListenerService.addListenerToToutiaohao('trial');
            //                 $timeout(function () {
            //                     window.close();
            //                 }, 2000);
            //             },
            //             function (data) {
            //                 modalDialog.alertType('撤稿失败', data.message, 'error', 'confirm');
            //             }
            //         );
            //     });
            // });
        };

        /**
         * [Trial description]送审操作
         * @return {[type]} [description]
         */
        $scope.Trial = function () {
            newMediaService.trial($scope, toutConst.trial).then((opinion) => {
                saveList().then(function () {
                    let toutiaoParams = angular.extend({
                        METADATAIDS: $state.params.articleid,
                        CHANNELID: $state.params.account,
                        opinion: opinion,
                    }, toutConst.trial);
                    messagePublishService.publish('doEditPageOperation', toutiaoParams);
                });
            });

            // modalDialog.inputModel('送审', '送审意见（选填）', function (content) {
            //     saveList().then(function (data) {
            //         var params = {
            // serviceid: 'mlf_toutiaooper',
            // methodname: 'trialTouTiaoArticles',
            // METADATAIDS: $state.params.articleid,
            // CHANNELID: $state.params.account,
            // opinion: content,
            //         };
            //         $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
            //             function (data) {
            //                 modalDialog.alertType('送审成功', '', 'success', false, function () { });
            //                 storageListenerService.addListenerToToutiaohao('send');
            //                 $timeout(function () {
            //                     window.close();
            //                 }, 2000);
            //             },
            //             function () {
            //                 modalDialog.alertType('送审失败', data.message, 'true', 'confirm');
            //             }
            //         );
            //     });
            // });
        };

        /**
         * [packageReSignParams description] 组装强制签发参数
         * @param   {[type]}  params         [params description]
         * @param   {[type]}  selectedArray  [selectedArray description]
         * @return  {[type]}                 [return description]
         */
        function packageReSignParams(params, selectedArray){
            params.METADATAIDS = selectedArray[0].DOC.METADATAID;
        }

        /**
         * [Sign description]签发操作
         * @return {[type]} [description]
         */
        $scope.Sign = function () {
            $scope.loadingPromise = newMediaService.sign($scope, '', function(params, selectedArray) {
                params.METADATAIDS = selectedArray[0].DOC.METADATAID;
            }).then(() => {
                saveList().then(() => {
                    let signParams = angular.extend({
                        METADATAIDS: $state.params.articleid,
                        CHANNELID: $state.params.account,
                    }, $state.params.platform === '1' ? toutConst.signOfDaishen : toutConst.signOfDaibian);
                    messagePublishService.publish('doEditPageOperation', signParams);
                });
            });
            // modalDialog.confirmModal('签发', '确认直接签发?', function () {
            //     saveList().then(function (data) {
            //         sign(data);
            //     });
            // });
        };

        /**
         * [sign description]
         *
         * @param   {[type]}  data  [data description]
         *
         * @return  {[type]}        [return description]
         */
        function sign(data) {
            var params = {
                serviceid: 'mlf_toutiaooper',
                METADATAIDS: data.METADATAID,
                CHANNELID: $state.params.account,
            };
            params.methodname = $state.params.platform === '1' ? 'touTiaoDaiShenPublish' : 'touTiaoDaiBianPublish';
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post', true).then(
                function (data) {
                    modalDialog.alertType('签发成功', '', 'success', false, function () { });
                    storageListenerService.addListenerToToutiaohao('sign');
                    $timeout(function () {
                        window.close();
                    }, 2000);
                },
                function (data) {
                    var options = {
                        params: params,
                        callback: function(params, selectedArray) {
                            params.METADATAIDS = selectedArray[0].DOC.METADATAID;
                        }
                    };
                    editingCenterService.issuedByForce(data, options).then(function(result) {
                        if (result) {
                            storageListenerService.addListenerToToutiaohao('sign');
                            window.close();
                        }
                    });
                }
            );
        }

        /**
         * [updateCKSelection description]更新稿费状态
         * @param  {[obj]} list [description]稿件对象
         * @return {[type]}     [description]
         */
        $scope.updateCKSelection = function (list) {
            list.ISNOPAYMENT = list.ISNOPAYMENT === '1' ? '0' : '1';
        };

        /**
         * [theFormError description] 获取表单变化
         * @return {[type]} [description]
         */
        $scope.theFormError = function () {
            // 当表单发生变化时会进入方法
            var errorArray = [];
            for (var error in $scope.tthNewsForm.$error) {
                errorArray.push(error);
            }
            $scope.status.tthNewsForm = $scope.status.tthNewsForm == undefined ? [] : $scope.status.tthNewsForm;
            if ($scope.status.tthNewsForm.length != errorArray.length) {
                // 长度不相等说明表单errorname发生变化
                $scope.status.tthNewsForm = errorArray;
            }
            return $scope.status.tthNewsForm; // 返回
        };

        /**
         * [toggleEditor description] 切换编辑器显隐
         * @return {[type]} [description]
         */
        $scope.toggleEditor = function () {
            $scope.status.zhengwen = !$scope.status.zhengwen;
            if ($scope.status.zhengwen) {
                // 隐藏编辑器
                $('.body_manuscript_content').addClass('editorHidden');
            } else {
                $('.body_manuscript_content').removeClass('editorHidden');
            }
        };

        /**
         * [revise 修订操作]
         *
         * @return  {[type]}
         *   [return description]
         */
        $scope.revise = function () {
            modalDialog.confirmModal('修订', '确认修订?', function () {
                saveList().then(function (data) {
                    var params = {
                        MediaType: '20',
                    };
                    $scope.loadingPromise = editingCenterService.reviseFinished(params);
                });
            });
        };

        /**  流程版本开始 */

        /**
         * [getVersion 获取流程版本]
         *
         * @param  {[type]}  id
         *   [id description]
         *
         * @return  {[type]}
         *   [return description]
         */
        function getVersion(id) {
            var deferred = $q.defer();
            var metadataid = angular.isDefined(id) ? id : $state.params.wzmetadataid;
            metadataid = $state.params.iwometadataid ? $state.params.iwometadataid : metadataid;
            editingCenterService.getEditVersionTime(metadataid, $scope.page, $scope.data.copyVersion).then(
                function (data) {
                    $scope.data.version = data;
                    $scope.page = data.page;
                    $scope.data.copyVersion = data.copyArray;
                    $scope.status.hasTimeline = true;
                    $scope.data.lastVersionid = data.lastVersionid;
                    deferred.resolve();
                },
                function () {
                    deferred.resolve();
                }
            );
            return deferred.promise;
        }

        /**
         * [isShowVersion description] 没有操作日志或流程版本时不显示图标和'没有更多'
         * @param  {[type]}  key [description] 操作日志或流程版本的数据
         * @return {Boolean}     [description]
         */
        $scope.isShowVersion = function (key) {
            if (key === undefined) {
                return false;
            } else {
                for (var i in key) {
                    return true;
                }
                return false;
            }
        };

        /**
         * [getLoadMore description]操作日志加载更多
         * @return {[type]} [description]
         */
        $scope.getLoadMore = function () {
            $scope.page.CURRPAGE++;
            getVersion();
        };

        /**
         * [getComment 获取评审意见]
         *
         * @param  {[type]}  id
         *   [id description]
         * @param  {[type]}  currPage
         *   [currPage description]
         *
         * @return  {[type]}
         *   [return description]
         */
        function getComment(id, currPage) {
            editingCenterService.getComment(id, currPage).then(function (data) {
                $scope.data.comment['comment'] = $scope.data.comment['comment'].concat(data.comment);
                $scope.data.comment.hasMore = data.hasMore;
                for (var i in data.voiceObj) {
                    $scope.data.comment.voiceObj[i] = data.voiceObj[i];
                }
            });
        }

        /**
         * [getComment description]获取评审意见
         * @return {[type]} [description]
         */
        $scope.getLoadMoreComment = function () {
            $scope.data.comment.currPage += 1;
            getComment($state.params.wzmetadataid, $scope.data.comment.currPage);
        };

        /**
         * [closeCurrView description] 页面关闭
         * @return  {[type]}  [return description]
         */
        $scope.closeCurrView = function() {
            toutiaohaoService.toutiaohaoUnlock($scope.tthNewsForm, $state.params.articleid, saveList, $scope.list);
        };

        /**
         * [emitCloseWindow description]标签页关闭页面时，发送稿件解锁信息给其他页面，协助解锁该稿件
         * @return {[type]} [description]
         */
        function emitCloseWindow() {
            // window.onbeforeunload = function() {
            //     if ($state.params.articleid) {
            //         localStorageService.set('unLocakDraft', JSON.stringify({ metadataid: $state.params.articleid }));
            //     }
            // };
            editingCenterService.allAppCloseWindow($scope, {typeName: 'article', saveLocal: false});
        }
    },
]);
